let notificationKey = 0;

export const CLEAR = '@@notifications/CLEAR',
    HIDE = '@@notifications/HIDE',
    SHOW = '@@notifications/SHOW',
    notificationsClear = () => ({type: CLEAR}),
    notificationsHide = (key) => ({type: HIDE, key}),
    notificationsShow = (notification = {}, delay = null) => dispatch => {
        const key = notificationKey += 1,
            dismiss = () => dispatch(notificationsHide(key)),
            timeout = delay
                ? setTimeout(dismiss, delay)
                : null;
        dispatch({
            type: SHOW,
            payload: {
                key,
                onDismiss: timeout
                    ? null
                    : dismiss,
                ...notification
            }
        });
    },
    showServerError = (response, delay) => notificationsShow({
        header: `Error ${response.status}`,
        error: true,
        content: response.statusText
    }, delay);


// WEBPACK FOOTER //
// ./src/actions/notifications.js